import { useTranslation } from "react-i18next";
import { Icon } from "@majourneys/icons";
import { BEVEL_CHIP_ON, BEVEL_INSET_NAVY, BEVEL_INSET_WHITE, BEVEL_NAVY_FACE, BEVEL_WHITE_FACE } from "@majourneys/shared/ui";

const NAVY = "#110E39";

/**
 * Map / List on the Stays hub. `inline` sits beside Filters on a desk and
 * matches it; `floating` joins the phone's floating Filters pill.
 */
export function StaysMapToggle({
  on,
  onChange,
  variant,
}: {
  on: boolean;
  onChange: (next: boolean) => void;
  variant: "inline" | "floating";
}) {
  const { t } = useTranslation();
  const label = on ? t("stays.hub_map.hide") : t("stays.hub_map.show");
  const icon = on ? "ri-layout-grid-line" : "ri-map-2-line";

  if (variant === "floating") {
    return (
      <button
        type="button"
        onClick={() => onChange(!on)}
        aria-pressed={on}
        className="pointer-events-auto inline-flex h-12 items-center gap-2 rounded-full px-5 text-[15px] font-semibold text-white transition-transform hover:scale-[1.03] active:scale-[0.97]"
        style={{ background: BEVEL_NAVY_FACE, boxShadow: `0 14px 30px -8px rgba(17,14,57,0.55), ${BEVEL_INSET_NAVY}` }}
      >
        <Icon name={icon} className="text-[18px]" aria-hidden="true" />
        {label}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={() => onChange(!on)}
      aria-pressed={on}
      className="hidden h-14 shrink-0 items-center gap-2 rounded-full px-5 text-[15px] font-semibold transition-[transform,box-shadow] duration-200 active:scale-[0.98] lg:inline-flex"
      style={
        on
          ? { background: BEVEL_NAVY_FACE, color: "#fff", boxShadow: BEVEL_CHIP_ON }
          : { background: BEVEL_WHITE_FACE, color: NAVY, boxShadow: `${BEVEL_INSET_WHITE}, 0 0 0 1px rgba(17,14,57,0.12)` }
      }
    >
      <Icon name={icon} className="text-[18px]" aria-hidden="true" />
      {label}
    </button>
  );
}
